<template>
    <info-widget :collapsible="true" :is-expanded="expanded" @toggle_expand="$emit('toggle_expand')">
        <template v-slot:title>Check History</template>

        <slot v-if="!$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.PAYCHECKS_ROLES)">
            <div class="info-widget-empty p-2">
                This information is not available to your security role.
            </div>
        </slot>

        <slot v-if="$permissions.hasRolesInCompany(client.id, employee.company_id, $store.state.security_roles.PAYCHECKS_ROLES)">
            <div v-if="employee && checks.length">
                <section class="table-section">
                    <div class="table-wrapper table-responsive">
                        <table class="table css-table widget-table table-fixed">
                            <thead>
                                <tr>
                                    <th class="cw-checknum">Check Num</th>
                                    <th class="cw-7 cell-right">Check Date</th>
                                    <th class="cw-pay cell-right">Net Pay</th>
                                    <th class="cw-7">Check Type</th>
                                </tr>
                            </thead>
                            <tbody v-for="(check, i) in visibleChecks" :key="check.id" :class="{'active-item': check.id == activeCheckId}">
                                <tr>
                                    <td class="cw-checknum">
                                        <a href @click.prevent="onCheckClicked(check)">
                                            <!-- Blank if no check number -->
                                            {{ check.check_number || '' }}
                                        </a>
                                    </td>
                                    <td class="cw-7 cell-right">
                                        <a href @click.prevent="onCheckClicked(check)">
                                            {{ $filters.dateshort(check.check_date) }}
                                        </a>
                                    </td>
                                    <td class="cw-pay cell-right">
                                        <span>
                                            ${{ check.net_pay }}
                                        </span>
                                    </td>
                                    <td class="cw-7">
                                        <span>
                                            {{ check.check_type_display }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
                <div v-if="!showAllChecks && employee && checks.length > 5" class="pb-1">
                    <button type="button" class="btn btn-link btn-block" @click.prevent="showAllChecks = true">
                        See all
                    </button>
                </div>
                <div v-if="showAllChecks && employee && checks.length > 5" class="pb-1">
                    <button type="button" class="btn btn-link btn-block" @click.prevent="showAllChecks = false">
                        See fewer
                    </button>
                </div>
            </div>
            <div v-if="!checks.length">
                <div class="info-widget-empty p-2">
                    This employee has no check history.
                </div>
            </div>
        </slot>
    </info-widget>

    <paycheck-modal :client="client" :paycheck="currentCheck" v-if="currentCheck" ref="paycheckModal" @close="currentCheck = null" />
</template>

<script>
import ButtonRow from '@/components/ButtonRow'
import InfoWidget from '@/components/InfoWidget'
import PaycheckModal from '@/components/PaycheckModal'

export default {
    components: {ButtonRow, InfoWidget, PaycheckModal},
    props: ['employee', 'client', 'checks', 'activeCheckId', 'expanded'],
    emits: ['toggle_expand'],
    computed: {
        visibleChecks() {
            if (!this.showAllChecks) {
                return this.checks.slice(0, 5)
            }

            return this.checks
        },
    },
    data() {
        return {
            currentCheck: null,
            showAllChecks: Boolean(this.activeCheckId),
        }
    },
    methods: {
        onCheckClicked(check) {
            this.currentCheck = check
            this.$nextTick(() => {
                this.$refs.paycheckModal.open()
            })
        },
    },
}
</script>
